import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Slide19WhyInvest() {
  const reasons = ['Built on real needs from major Swedish media agency', 'Demanded by FMCG brands', 'Unique ecosystem (digital + physical + AI)', 'Halves sampling costs', 'Global scalability', 'Early traction already achieved'];
  return <div className="flex flex-col h-full justify-center max-w-6xl mx-auto w-full" data-id="element-228">
      <motion.h2 className="text-5xl font-bold text-[#ffd700] mb-16 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} data-id="element-229">
        Why Invest
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-230">
        {reasons.map((reason, i) => <motion.div key={i} initial={{
        x: -20,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} transition={{
        delay: i * 0.15
      }} className="flex items-center gap-4 p-4" data-id="element-231">
            <div className="w-8 h-8 rounded-full bg-[#4fd1c5]/20 flex items-center justify-center flex-shrink-0" data-id="element-232">
              <Check className="w-5 h-5 text-[#4fd1c5]" data-id="element-233" />
            </div>
            <span className="text-xl text-white" data-id="element-234">{reason}</span>
          </motion.div>)}
      </div>

      <motion.div className="text-center" initial={{
      y: 50,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 0.8
    }} data-id="element-235">
        <p className="text-3xl font-light text-white/90 italic" data-id="element-236">
          "We are building the future global sampling infrastructure."
        </p>
      </motion.div>
    </div>;
}